import { apiSliceV2Generated as api } from "../../../../apiSlice";
export const addTagTypes = ["EnergyGroups"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getEnergyGroup: build.query<
        GetEnergyGroupApiResponse,
        GetEnergyGroupApiArg
      >({
        query: (queryArg) => ({ url: `/v2/EnergyGroups/${queryArg.groupId}` }),
        providesTags: ["EnergyGroups"],
      }),
      putEnergyGroup: build.mutation<
        PutEnergyGroupApiResponse,
        PutEnergyGroupApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/EnergyGroups/${queryArg.groupId}`,
          method: "PUT",
          body: queryArg.putEnergyGroupDto,
        }),
        invalidatesTags: ["EnergyGroups"],
      }),
      deleteEnergyGroup: build.mutation<
        DeleteEnergyGroupApiResponse,
        DeleteEnergyGroupApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/EnergyGroups/${queryArg.groupId}`,
          method: "DELETE",
        }),
        invalidatesTags: ["EnergyGroups"],
      }),
      getEnergyGroups: build.query<
        GetEnergyGroupsApiResponse,
        GetEnergyGroupsApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/EnergyGroups`,
          params: {
            AccountIds: queryArg.accountIds,
            OrderBy: queryArg.orderBy,
            OrderDirection: queryArg.orderDirection,
            Top: queryArg.top,
            Skip: queryArg.skip,
            type: queryArg["type"],
          },
        }),
        providesTags: ["EnergyGroups"],
      }),
      postEnergyGroup: build.mutation<
        PostEnergyGroupApiResponse,
        PostEnergyGroupApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/EnergyGroups`,
          method: "POST",
          body: queryArg.postEnergyGroupDto,
        }),
        invalidatesTags: ["EnergyGroups"],
      }),
      putEnergyGroupOptions: build.mutation<
        PutEnergyGroupOptionsApiResponse,
        PutEnergyGroupOptionsApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/EnergyGroups/${queryArg.groupId}/Options`,
          method: "PUT",
          body: queryArg.putEnergyGroupOptionsDto,
        }),
        invalidatesTags: ["EnergyGroups"],
      }),
      putEnergyGroupState: build.mutation<
        PutEnergyGroupStateApiResponse,
        PutEnergyGroupStateApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/EnergyGroups/${queryArg.groupId}/State`,
          method: "PUT",
          body: queryArg.energyGroupState,
        }),
        invalidatesTags: ["EnergyGroups"],
      }),
      getEnergyGroupInitiative: build.query<
        GetEnergyGroupInitiativeApiResponse,
        GetEnergyGroupInitiativeApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/EnergyGroups/${queryArg.groupId}/Initiative/${queryArg.initiativeId}`,
        }),
        providesTags: ["EnergyGroups"],
      }),
      putEnergyGroupInitiative: build.mutation<
        PutEnergyGroupInitiativeApiResponse,
        PutEnergyGroupInitiativeApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/EnergyGroups/${queryArg.groupId}/Initiative/${queryArg.initiativeId}`,
          method: "PUT",
          body: queryArg.putEnergyInitiativeDto,
        }),
        invalidatesTags: ["EnergyGroups"],
      }),
      deleteEnergyGroupInitiative: build.mutation<
        DeleteEnergyGroupInitiativeApiResponse,
        DeleteEnergyGroupInitiativeApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/EnergyGroups/${queryArg.groupId}/Initiative/${queryArg.initiativeId}`,
          method: "DELETE",
        }),
        invalidatesTags: ["EnergyGroups"],
      }),
      postEnergyGroupInitiative: build.mutation<
        PostEnergyGroupInitiativeApiResponse,
        PostEnergyGroupInitiativeApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/EnergyGroups/${queryArg.groupId}/Initiative`,
          method: "POST",
          body: queryArg.postEnergyInitiativeDto,
        }),
        invalidatesTags: ["EnergyGroups"],
      }),
      getEnergyGroupEnergyTreeNode: build.query<
        GetEnergyGroupEnergyTreeNodeApiResponse,
        GetEnergyGroupEnergyTreeNodeApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/EnergyGroups/${queryArg.groupId}/Node/${queryArg.nodeId}`,
        }),
        providesTags: ["EnergyGroups"],
      }),
      putEnergyGroupEnergyTreeNode: build.mutation<
        PutEnergyGroupEnergyTreeNodeApiResponse,
        PutEnergyGroupEnergyTreeNodeApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/EnergyGroups/${queryArg.groupId}/Node/${queryArg.nodeId}`,
          method: "PUT",
          body: queryArg.putEnergyTreeNodeDto,
        }),
        invalidatesTags: ["EnergyGroups"],
      }),
      deleteEnergyGroupEnergyTreeNode: build.mutation<
        DeleteEnergyGroupEnergyTreeNodeApiResponse,
        DeleteEnergyGroupEnergyTreeNodeApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/EnergyGroups/${queryArg.groupId}/Node/${queryArg.nodeId}`,
          method: "DELETE",
        }),
        invalidatesTags: ["EnergyGroups"],
      }),
      postEnergyGroupEnergyTreeNode: build.mutation<
        PostEnergyGroupEnergyTreeNodeApiResponse,
        PostEnergyGroupEnergyTreeNodeApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/EnergyGroups/${queryArg.groupId}/Node`,
          method: "POST",
          body: queryArg.postEnergyTreeNodeDto,
        }),
        invalidatesTags: ["EnergyGroups"],
      }),
      putEnergyGroupEnergyTreeNodeOptions: build.mutation<
        PutEnergyGroupEnergyTreeNodeOptionsApiResponse,
        PutEnergyGroupEnergyTreeNodeOptionsApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/EnergyGroups/${queryArg.groupId}/Node/${queryArg.nodeId}/Options`,
          method: "PUT",
          body: queryArg.putEnergyTreeNodeOptionsDto,
        }),
        invalidatesTags: ["EnergyGroups"],
      }),
      putEnergyGroupEnergyTreeNodes: build.mutation<
        PutEnergyGroupEnergyTreeNodesApiResponse,
        PutEnergyGroupEnergyTreeNodesApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/EnergyGroups/${queryArg.groupId}/Nodes`,
          method: "PUT",
          body: queryArg.body,
        }),
        invalidatesTags: ["EnergyGroups"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as recalcV2OpenApi };
export type GetEnergyGroupApiResponse = /** status 200 OK */ GetEnergyGroupDto;
export type GetEnergyGroupApiArg = {
  groupId: number;
};
export type PutEnergyGroupApiResponse = unknown;
export type PutEnergyGroupApiArg = {
  groupId: number;
  putEnergyGroupDto: PutEnergyGroupDto;
};
export type DeleteEnergyGroupApiResponse = unknown;
export type DeleteEnergyGroupApiArg = {
  groupId: number;
};
export type GetEnergyGroupsApiResponse =
  /** status 200 OK */ GetEnergyGroupDto[];
export type GetEnergyGroupsApiArg = {
  accountIds?: number[];
  orderBy?: string;
  orderDirection?: "desc" | "asc";
  top?: number;
  skip?: number;
  type?: EnergyGroupType;
};
export type PostEnergyGroupApiResponse =
  /** status 201 Created */ GetEnergyGroupDto;
export type PostEnergyGroupApiArg = {
  postEnergyGroupDto: PostEnergyGroupDto;
};
export type PutEnergyGroupOptionsApiResponse = unknown;
export type PutEnergyGroupOptionsApiArg = {
  groupId: number;
  putEnergyGroupOptionsDto: PutEnergyGroupOptionsDto;
};
export type PutEnergyGroupStateApiResponse = unknown;
export type PutEnergyGroupStateApiArg = {
  groupId: number;
  energyGroupState: EnergyGroupState;
};
export type GetEnergyGroupInitiativeApiResponse =
  /** status 200 OK */ GetEnergyInitiativeDto;
export type GetEnergyGroupInitiativeApiArg = {
  groupId: number;
  initiativeId: number;
};
export type PutEnergyGroupInitiativeApiResponse = unknown;
export type PutEnergyGroupInitiativeApiArg = {
  groupId: number;
  initiativeId: number;
  putEnergyInitiativeDto: PutEnergyInitiativeDto;
};
export type DeleteEnergyGroupInitiativeApiResponse = unknown;
export type DeleteEnergyGroupInitiativeApiArg = {
  groupId: number;
  initiativeId: number;
};
export type PostEnergyGroupInitiativeApiResponse =
  /** status 201 Created */ GetEnergyInitiativeDto;
export type PostEnergyGroupInitiativeApiArg = {
  groupId: number;
  postEnergyInitiativeDto: PostEnergyInitiativeDto;
};
export type GetEnergyGroupEnergyTreeNodeApiResponse =
  /** status 200 OK */ GetEnergyTreeNodeDto;
export type GetEnergyGroupEnergyTreeNodeApiArg = {
  groupId: number;
  nodeId: string;
};
export type PutEnergyGroupEnergyTreeNodeApiResponse = unknown;
export type PutEnergyGroupEnergyTreeNodeApiArg = {
  groupId: number;
  nodeId: string;
  putEnergyTreeNodeDto: PutEnergyTreeNodeDto;
};
export type DeleteEnergyGroupEnergyTreeNodeApiResponse = unknown;
export type DeleteEnergyGroupEnergyTreeNodeApiArg = {
  groupId: number;
  nodeId: string;
};
export type PostEnergyGroupEnergyTreeNodeApiResponse =
  /** status 201 Created */ GetEnergyTreeNodeDto;
export type PostEnergyGroupEnergyTreeNodeApiArg = {
  groupId: number;
  postEnergyTreeNodeDto: PostEnergyTreeNodeDto;
};
export type PutEnergyGroupEnergyTreeNodeOptionsApiResponse = unknown;
export type PutEnergyGroupEnergyTreeNodeOptionsApiArg = {
  groupId: number;
  nodeId: string;
  putEnergyTreeNodeOptionsDto: PutEnergyTreeNodeOptionsDto;
};
export type PutEnergyGroupEnergyTreeNodesApiResponse = unknown;
export type PutEnergyGroupEnergyTreeNodesApiArg = {
  groupId: number;
  body: PutEnergyTreeNodesItemDto[];
};
export type EnergyGroupType =
  | "Water"
  | "Heat"
  | "Power"
  | "PortfolioWater"
  | "PortfolioHeat"
  | "PortfolioPower";
export type EnergyGroupState =
  | "Synced"
  | "Desynced"
  | "Processing"
  | "New"
  | "Error";
export type GetEnergyGroupOptionsDto = {
  state: EnergyGroupState;
  isDraftMode: boolean;
};
export type EnergyInitiativeState =
  | "Created"
  | "Active"
  | "Done"
  | "Initialized"
  | "Archived";
export type GetEnergyInitiativeDto = {
  energyInitiativeId?: number;
  energyGroupId?: number;
  name?: string | null;
  description?: string | null;
  state?: EnergyInitiativeState;
  completed?: string | null;
  baselineStart?: string | null;
  baselineEnd?: string | null;
  comparisonStart?: string | null;
  comparisonEnd?: string | null;
  preferredModel?: number;
  energyTreeNodes?: string[] | null;
  created?: string;
  changed?: string | null;
};
export type EnergyTreeNodeDataStreamDto = {
  unitId?: number;
  unitTypeInputId?: number;
  dataType?: string | null;
  aggregateType?: string | null;
};
export type SpecialNodeType =
  | "FlatResidual"
  | "PercentageResidual"
  | "RestResidual";
export type GetEnergyTreeNodeOptionsDto = {
  specialNodeType?: SpecialNodeType;
  percentage?: number | null;
  consumption?: number | null;
  openingHours?: any | null;
  goShares?: any[] | null;
};
export type GetEnergyTreeNodeDto = {
  energyTreeNodeId?: string;
  energyGroupId?: number;
  name?: string | null;
  type?: string | null;
  parentId?: string | null;
  dataStreams?: EnergyTreeNodeDataStreamDto[] | null;
  options?: GetEnergyTreeNodeOptionsDto;
  locationId?: number | null;
};
export type GetEnergyGroupDto = {
  energyGroupId?: number;
  name?: string | null;
  type?: EnergyGroupType;
  accountId?: number;
  buildingId?: number | null;
  locationId?: number;
  options?: GetEnergyGroupOptionsDto;
  created?: string;
  changed?: string | null;
  energyInitiatives?: GetEnergyInitiativeDto[] | null;
  energyTreeNodes?: GetEnergyTreeNodeDto[] | null;
};
export type ProblemDetails = {
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: any;
};
export type PutEnergyGroupDto = {
  name?: string | null;
  type?: EnergyGroupType;
  buildingId?: number | null;
  locationId?: number;
};
export type PostEnergyGroupOptionsDto = {
  state: EnergyGroupState;
  isDraftMode: boolean;
};
export type PostEnergyGroupDto = {
  accountId?: number;
  options?: PostEnergyGroupOptionsDto;
  name?: string | null;
  type?: EnergyGroupType;
  buildingId?: number | null;
  locationId?: number;
};
export type PutEnergyGroupOptionsDto = {
  isDraftMode: boolean;
};
export type PutEnergyInitiativeDto = {
  name?: string | null;
  description?: string | null;
  state?: EnergyInitiativeState;
  completed?: string | null;
  baselineStart?: string | null;
  baselineEnd?: string | null;
  comparisonStart?: string | null;
  comparisonEnd?: string | null;
  preferredModel?: number;
  energyTreeNodes?: string[] | null;
};
export type PostEnergyInitiativeDto = {
  name?: string | null;
  description?: string | null;
  state?: EnergyInitiativeState;
  completed?: string | null;
  baselineStart?: string | null;
  baselineEnd?: string | null;
  comparisonStart?: string | null;
  comparisonEnd?: string | null;
  preferredModel?: number;
  energyTreeNodes?: string[] | null;
};
export type PutEnergyTreeNodeOptionsDto = {
  specialNodeType?: SpecialNodeType | null;
  percentage?: number | null;
  consumption?: number | null;
  openingHours?: any | null;
  goShares?: any[] | null;
};
export type PutEnergyTreeNodeDto = {
  name?: string | null;
  type?: string | null;
  parentId?: string | null;
  dataStreams?: EnergyTreeNodeDataStreamDto[] | null;
  options?: PutEnergyTreeNodeOptionsDto;
  locationId?: number | null;
};
export type PostEnergyTreeNodeOptionsDto = {
  specialNodeType?: SpecialNodeType | null;
  percentage?: number | null;
  consumption?: number | null;
  openingHours?: any | null;
  goShares?: any[] | null;
};
export type PostEnergyTreeNodeDto = {
  name?: string | null;
  type?: string | null;
  parentId?: string | null;
  dataStreams?: EnergyTreeNodeDataStreamDto[] | null;
  options?: PostEnergyTreeNodeOptionsDto;
  locationId?: number | null;
};
export type PutEnergyTreeNodesItemDto = {
  name?: string | null;
  type?: string | null;
  parentId?: string | null;
  dataStreams?: EnergyTreeNodeDataStreamDto[] | null;
  options?: PutEnergyTreeNodeOptionsDto;
  locationId?: number | null;
  energyTreeNodeId?: string | null;
  tempTreePositionId: string | null;
  tempParentTreePositionId?: string | null;
};
export const {
  useGetEnergyGroupQuery,
  usePutEnergyGroupMutation,
  useDeleteEnergyGroupMutation,
  useGetEnergyGroupsQuery,
  usePostEnergyGroupMutation,
  usePutEnergyGroupOptionsMutation,
  usePutEnergyGroupStateMutation,
  useGetEnergyGroupInitiativeQuery,
  usePutEnergyGroupInitiativeMutation,
  useDeleteEnergyGroupInitiativeMutation,
  usePostEnergyGroupInitiativeMutation,
  useGetEnergyGroupEnergyTreeNodeQuery,
  usePutEnergyGroupEnergyTreeNodeMutation,
  useDeleteEnergyGroupEnergyTreeNodeMutation,
  usePostEnergyGroupEnergyTreeNodeMutation,
  usePutEnergyGroupEnergyTreeNodeOptionsMutation,
  usePutEnergyGroupEnergyTreeNodesMutation,
} = injectedRtkApi;
